// @ts-nocheck

'use client';

import { Suspense, useState } from 'react';
import FilterBar from '@/components/custom/listing/FilterBar';
import PropertyList from '@/components/custom/listing/PropertyList';
import MapView from '@/components/custom/listing/MapView';
import { usePropertyListing } from '@/hooks/usePropertyListing';

function ListingsContent() {
    const {
        filters,
        setFilters,
        properties,
        propertyTypesList,
        areaList,
        loading,
        error,
        amenitiesList
    } = usePropertyListing();

    const [hoveredPropertyId, setHoveredPropertyId] = useState<string | null>(null);

    return (
        <div className="min-h-screen flex flex-col pt-32">
            <FilterBar
                filters={filters}
                onFilterChange={setFilters}
                propertyTypes={propertyTypesList}
                areaList={areaList}
                amenitiesList={amenitiesList}
            />

            <div className="flex-1 flex overflow-hidden relative">
                <div className="w-full lg:w-3/5 h-[calc(100vh-200px)]">
                    <PropertyList
                        properties={properties}
                        hoveredId={hoveredPropertyId}
                        onPropertyHover={setHoveredPropertyId}
                        loading={loading}
                    />
                </div>

                <div className="hidden lg:block lg:w-2/5 h-[calc(100vh-200px)] sticky top-[200px]">
                    <MapView
                        properties={properties}
                        hoveredId={hoveredPropertyId}
                        onPropertyHover={setHoveredPropertyId}
                    />
                </div>
            </div>
        </div>
    );
}

function Listings() {
    return (
        <Suspense fallback={<div className="min-h-screen pt-32 flex justify-center items-center">Loading...</div>}>
            <ListingsContent />
        </Suspense>
    );
}

export default Listings;
